import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import _ from 'lodash';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import * as iconMetaFile from '!yaml-js-loader!../../../assets/yml/font-awesome-icons-metadata.yaml';
import { IFontAwesomeIconMetadata } from './types/IFontAwesomeIconMetadata';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
   providedIn: 'root',
})
export class FontAwesomeEngineService {
   public icons$: Observable<IconDefinition[]>;
   public iconMetaData$: Observable<{ [iconKey: string]: IFontAwesomeIconMetadata }>;

   constructor() {
      const defaultIcons: IconDefinition[] = _.values(fad);
      const brandIcons: IconDefinition[] = _.values(fab);
      this.icons$ = from([[...defaultIcons, ...brandIcons]]);

      const testFile = iconMetaFile as any;
      const fontAwesomeIconMetadata = testFile.json as { [iconKey: string]: IFontAwesomeIconMetadata };
      this.iconMetaData$ = from([fontAwesomeIconMetadata]);
   }

   public filterIconsWithSearchValue(searchValueString: string): Observable<IconDefinition[]> {
      const searchValues = _.split(searchValueString, ' ');
      if (searchValues.length <= 0) {
         return this.icons$;
      }
      return this.iconMetaData$.pipe(
         map((metaData) => {
            const matchingMetaDatas: { [iconKey: string]: IFontAwesomeIconMetadata } = _.pickBy(metaData, (value, key) => {
               return _.every(searchValues, (searchValue) => {
                  return (
                     key.toLowerCase().includes(searchValue.toLowerCase()) ||
                     value.label.includes(searchValue.toLowerCase()) ||
                     value.search.terms.some((x) => x.includes(searchValue.toLowerCase()))
                  );
               });
            });
            return _.keys(matchingMetaDatas);
         }),
         switchMap((matchingIconKeys) =>
            this.icons$.pipe(
               map((icons) => {
                  return _.filter(icons, (icon) => matchingIconKeys.includes(icon.iconName));
               })
            )
         )
      );
   }
}
